import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  BooleanInput,
  required,
  useGetIdentity,
  TopToolbar,
  ListButton,
  ShowButton,
} from 'react-admin'
import { Typography, Box } from '@material-ui/core'
import { useTranslate } from 'ra-core'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import SortableQuestionIdsInput from '../../components/SortableQuestionIdsInput'
import CampaignLogoInput from '../../components/CampaignLogoInput'

const CampaignsEditActions = ({ identity, basePath }) => {
  let countryBasePath = ''
  if (identity.role !== 'admin') {
    countryBasePath = `${basePath}?filter={"country":"${identity.country}"}`
  }
  return (
    <TopToolbar>
      <ListButton basePath={countryBasePath} />
      <ShowButton />
    </TopToolbar>
  )
}

CampaignsEditActions.propTypes = {
  basePath: PropTypes.any,
  identity: PropTypes.any,
}

export const CampaignsEdit = props => {
  const translate = useTranslate()
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const country = identity.country

  return (
    <Edit actions={<CampaignsEditActions identity={identity} />} {...props}>
      <TabbedForm submitOnEnter={false} syncWithLocation={false}>
        <FormTab label={translate('surveys.campaigns.tab_summary_form')}>
          <TextInput source="name" validate={required()} fullWidth />
          <TextInput
            source="country"
            defaultValue={country}
            disabled
            fullWidth
          />
          <BooleanInput source="status" />
        </FormTab>
        <FormTab label={translate('surveys.campaigns.tab_appearance')}>
          <TextInput
            source="theme.background"
            fullWidth
            helperText={translate('surveys.campaigns.theme_background_help')}
          />
          <TextInput
            source="theme.accentColor"
            fullWidth
            helperText={translate('surveys.campaigns.theme_accent_color_help')}
          />
          <TextInput
            source="theme.titleColor"
            fullWidth
            helperText={translate('surveys.campaigns.theme_title_color_help')}
          />
          <TextInput
            source="theme.borderColor"
            fullWidth
            helperText={translate('surveys.campaigns.theme_border_color_help')}
          />
          <TextInput
            source="theme.buttonColor"
            fullWidth
            helperText={translate('surveys.campaigns.theme_button_color_help')}
          />
          <CampaignLogoInput source="theme.logoUrl" />
          <TextInput
            source="theme.surveyTitle"
            fullWidth
            helperText={translate('surveys.campaigns.theme_survey_title_help')}
          />
          <TextInput
            source="theme.surveySubtitle"
            fullWidth
            helperText={translate(
              'surveys.campaigns.theme_survey_subtitle_help',
            )}
          />
          <TextInput
            source="theme.step2Title"
            fullWidth
            helperText={translate('surveys.campaigns.theme_step2_title_help')}
          />
          <TextInput
            source="theme.step2Subtitle"
            fullWidth
            helperText={translate(
              'surveys.campaigns.theme_step2_subtitle_help',
            )}
          />
        </FormTab>
        <FormTab label={translate('surveys.campaigns.tab_questions')}>
          <Box mb={2}>
            <Typography variant="body2" color="textSecondary">
              {translate('surveys.campaigns.questions_hint')}
            </Typography>
          </Box>
          <SortableQuestionIdsInput
            source="questionIds"
            country={country}
            label={translate('surveys.campaigns.questions_order')}
          />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}
